export default __webpack_public_path__ + "static/roadmap-pattern-615cf411ef68802125d6e776f2d17dd0.svg";